import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import HeaderLogo from '../assets/header/footlogo.png';
import item1 from '../assets/image/Footer/twitter_normal.svg';
import item2 from '../assets/image/Footer/medium_normal.svg';
import item3 from '../assets/image/Footer/telegram_normal.svg';
import item4 from '../assets/image/Footer/Linkedin_normal.svg';
import item5 from '../assets/image/Footer/gitbook_normal.svg';
import item7 from '../assets/image/Footer/email_normal.svg';
import item1_hover from '../assets/image/Footer/twitter_hover.svg';
import item2_hover from '../assets/image/Footer/medium_hover.svg';
import item3_hover from '../assets/image/Footer/telegram_hover.svg';
import item4_hover from '../assets/image/Footer/Linkedin_hover.svg';
import item5_hover from '../assets/image/Footer/gitbook_hover.svg';
import item7_hover from '../assets/image/Footer/email_hover.svg';
import jump from '../assets/header/jump_grey.svg';
import jump_hover from '../assets/header/jump_hover.svg';
import { NavLink, useHistory } from 'react-router-dom';
import { MobileShowContainer, PcShowContainter } from './GlobalStyle';
import MobileFooter from './MobileFooter';
const LinkDom = styled.a `
  display: block;
  width: 40rem;
  height: 40rem;
  background-image: ${({ bg }) => bg && `url(${bg})`};
  background-size: 100% 100%;
  cursor: pointer;

  &:hover {
    background-image: ${({ bghover }) => bghover && `url(${bghover})`};
    background-size: 100% 100%;
  }
`;
export default function Footer({ className }) {
    const history = useHistory();
    const { t } = useTranslation('nav');
    const ImgDate = [item1, item2, item3, item4, item5, item7];
    const ImgDate_Hover = [item1_hover, item2_hover, item3_hover, item4_hover, item5_hover, item7_hover];
    const LinkJump = [
        'https://x.com/netx_world',
        'https://medium.com/@netxworld',
        'https://t.me/NetXPlatform',
        'https://www.linkedin.com/company/netx-foundation',
        'https://netx.gitbook.io/netx-docs',
        'mailto:contact@netx.world'
    ];
    const LinkDomContainer = ({ num }) => {
        const imageUrl = ImgDate[num];
        const imageHoverUrl = ImgDate_Hover[num];
        const href = LinkJump[num];
        const isMailLink = href.startsWith('mailto:');
        return (_jsx(LinkDom, { className: `item${num} item`, bg: imageUrl, bghover: imageHoverUrl, href: href, target: isMailLink ? undefined : '_blank', rel: isMailLink ? undefined : 'noopener noreferrer' }));
    };
    let menuItems = [
        {
            title: t('footer.ecosystem'),
            items: [
                { name: t('footer.nexus'), pathUrl: 'Nexus' },
                { name: t('footer.agentOS'), pathUrl: 'AgentOS' },
                { name: t('footer.payments'), pathUrl: 'payments' },
            ]
        },
        {
            title: t('footer.build'),
            items: [
                { name: t('footer.netxscan'), link: 'https://netxscan.io/', showRightPoint: true },
                { name: t('footer.faucet'), link: 'https://netx.world/faucet', target: '_self' },
                { name: t('footer.bridge'), pathUrl: 'bridge' },
            ]
        },
        {
            title: t('footer.participate'),
            items: [
                { name: t('footer.exchange'), pathUrl: 'exchange' },
                { name: t('footer.aiEngineer'), pathUrl: 'AI_engineer' },
                { name: t('footer.partnership'), pathUrl: 'partnership' },
                { name: t('footer.genesisBundle'), pathUrl: 'Genesis_Bundle' },
            ]
        },
        {
            title: t('footer.learn'),
            items: [
                { name: t('footer.technology'), pathUrl: 'technology' },
                { name: t('footer.economy'), pathUrl: 'economy' },
                { name: t('footer.tokenRelease'), pathUrl: 'token-release' },
                { name: t('footer.trustedComputing'), pathUrl: 'trusted_computing' },
                { name: t('footer.communityResearch'), pathUrl: 'research' },
            ]
        },
        {
            title: "",
            items: [
                { name: t('footer.whitepaper'), link: 'https://netx.gitbook.io/netx-docs/whitepaper/netx-enterprise-framework-nef', showRightPoint: true },
                { name: t('footer.roadmap'), link: 'https://netx.gitbook.io/netx-docs/roadmap', showRightPoint: true },
                { name: t('footer.brandResources'), link: 'https://netx.gitbook.io/netx-docs/brand-resources', showRightPoint: true },
            ]
        },
    ];
    return (_jsxs(_Fragment, { children: [_jsx(PcShowContainter, { children: _jsxs(FooterWrapper, { children: [_jsxs(FooterContent, { children: [_jsxs(LogoSection, { children: [_jsx(Logo, { src: HeaderLogo, alt: "NetX Logo", onClick: () => {
                                                history.push('/');
                                            } }), _jsx(IntroText, { children: t('tagline') }), _jsx(SocialIcons, { children: ImgDate.map((item, index) => (_jsx(LinkDomContainer, { num: index }, index))) })] }), _jsx(MenuSection, { children: menuItems.map((menu, index) => (_jsxs(MenuColumn, { className: menu.title ? menu.title.toLowerCase() : 'no-title', children: [menu.title && _jsx(MenuTitle, { children: menu.title }), menu.items.map((item, itemIndex) => {
                                                return (_jsx(React.Fragment, { children: item.link ?
                                                        _jsxs(MenuItem, { href: item.link, target: item.target ? item.target : '_blank', rel: "noopener noreferrer", children: [item.name, item.showRightPoint && _jsx(PointRight, { className: 'jump' })] }) : item.pathUrl ?
                                                        _jsx(NavLink, { to: `/${item.pathUrl}`, children: item.name }) : _jsx("span", {}) }, item.name));
                                            })] }, index))) })] }), _jsx(Divider, {}), _jsxs(IntroText1, { children: [t('footer.compliance'), " ", _jsx("a", { href: 'https://netx.gitbook.io/netx-docs/netx-compliance-and-service-agreement', target: '_blank', children: t('footer.learnMore') })] }), _jsx(Copyright, { children: t('footer.copyright') })] }) }), _jsx(MobileShowContainer, { children: _jsx(MobileFooter, {}) })] }));
}
const FooterWrapper = styled.footer `
  background: #101D42;
`;
const FooterContent = styled.div `
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: 72rem 68rem 48rem;

`;
const LogoSection = styled.div `
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex: none;
`;
const Logo = styled.img `
  width: 120rem;
  height: auto;
  margin-bottom: 34rem;
  cursor: pointer;
`;
const IntroText = styled.div `
  font-family: var(--netx-font);
  font-weight: 400;
  font-size: 16rem;
  color: #FFFFFF;
  line-height: 18rem;
  margin-bottom: 34rem;
`;
const SocialIcons = styled.div `
  display: flex;
  gap: 24rem;
`;
const IntroText1 = styled.div `
  font-family: var(--netx-font);
font-weight: 400;
font-size: 16rem;
color: rgba(159, 164, 179, 1);
line-height: 18rem;
max-width: 1600rem;
margin: 0 auto;
text-align: center;
padding-bottom: 24rem;
a{
  cursor: pointer;
  color: rgba(26, 105, 255, 1);
  border-bottom: 1ps solid  rgba(26, 105, 255, 1);
}
`;
const MenuSection = styled.div `
  display: flex;
  gap: 96rem;

`;
const PointRight = styled.div `
  display: inline-block;
  width: 16rem;
  height: 16rem;
  margin-left: 8rem;
  background: url(${jump});
  background-size: 100% 100%;

`;
const MenuColumn = styled.div `
  display: flex;
  flex-direction: column;

  &.no-title {
    padding-top: 64rem;
  }

  > a {
    color: rgba(255, 255, 255, .6);
    font-size: 16rem;
    font-weight: 300;
    margin-bottom: 32rem;
    display: flex;
    align-items: center;
    cursor: pointer;
    font-family: var(--netx-font);

    &:hover {
      color: #5585FC;

      .jump {
        background: url(${jump_hover});
        background-size: 100% 100%;
      }
    }
  }
`;
const MenuTitle = styled.h4 `
  font-family: var(--netx-font);
  font-weight: 500;
  font-size: 16rem;
  color: #FFFFFF;
  line-height: 16rem;
  margin-bottom: 24rem;
  padding-top: 22rem;
`;
const MenuItem = styled.a `
  color: rgba(255, 255, 255, 0.6);
  font-size: 16rem;
  font-weight: 300;
  margin-bottom: 32rem;
  display: flex;
  align-items: center;
  cursor: pointer;
  font-family: var(--netx-font);

  &:hover {
    color: #5585FC;

    .jump {
      background: url(${jump_hover});
      background-size: 100% 100%;
    }
  }
`;
const Divider = styled.hr `
  border: none;
  border-top: 1rem solid #2e2e2e;
  margin: 32rem 0;
`;
const Copyright = styled.p `
  text-align: center;
  font-size: 14rem;
  font-weight: 300;
  height: 47rem;
  color: #fff;
`;
